module.exports = __webpack_public_path__ + "img/login.8d9a3a34.png";